import { HTMLAttributes } from 'react'

import Container from '@/components/base/container'
import Grid from '@/components/base/grid'
import Section from '@/components/base/section'
import Typography from '@/components/base/typography'
import Spacer from '@/components/sections/spacer'
import { useStore } from '@/contexts/store'

import { cn } from '@/lib/utils'

type ProjectCreditsProps = HTMLAttributes<HTMLDivElement> &
  Partial<{
    collection: {
      role: string
      name: string
    }[]
  }>

const ProjectCredits = ({
  collection,
  className,
  ...props
}: ProjectCreditsProps) => {
  const { strings } = useStore()

  return (
    <Section className={cn(className)} {...props}>
      <Spacer variant="xl" />
      <Container>
        <Grid className="items-baseline gap-y-spacing-sm">
          <div className="col-span-2 md:col-span-6 lg:col-span-2 xl:col-span-3">
            <Typography
              variant="small"
              className="condensed text-text-heading-light dark:text-text-heading-dark"
            >
              {strings?.labels?.project_credits_title || 'Credits'}
            </Typography>
          </div>

          <div className="col-span-2 md:col-span-6 lg:col-span-10 xl:col-span-9">
            <div className="grid gap-y-spacing-sm md:grid-cols-2 md:gap-x-spacing-md lg:grid-cols-2 lg:gap-x-spacing-sm xl:grid-cols-3">
              {(collection || []).map((item, index) => (
                <div
                  key={`project-credit-${item.role}-${item.name}-${index}`}
                  className="flex items-end gap-[32px]"
                >
                  <Typography
                    variant="regular"
                    className="condensed mb-[1px] min-w-[80px]"
                  >
                    {item.role}
                  </Typography>
                  <Typography
                    variant="large"
                    className="md:text-large text-text-primary-light dark:text-text-primary-dark"
                  >
                    {item.name}
                  </Typography>
                </div>
              ))}
            </div>
          </div>
        </Grid>
      </Container>
      <Spacer variant="xl" />
    </Section>
  )
}

export default ProjectCredits
